/**
 * Created by staffanrantzow on 16/03/16.
 */

/* @flow */
import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import { Link } from 'react-router';
import { CustomerService } from 'frilans-finans';
import Utils from 'frilans-finans/utils/utils';
import { CountryPicker, Spinner, GeneralError, SpinnerButton, InputField, PayTermsPicker } from 'components';

export class Customer extends React.Component {

  static propTypes = {
    params: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      name: '',
      showErrorWithoutBlur: false,
      posting: false,
      fetching: true,
      fetchError: false,
      postError: false,
      customer: null,
      customerUpdated: false,
      countryOrgNumError: false,
      pendingRequestGetById: null
    };

    this.newValueFromChild = this.newValueFromChild.bind(this);
    this.clickSubmit = this.clickSubmit.bind(this);
    this.setCountry = this.setCountry.bind(this);
    this.setPayTerms = this.setPayTerms.bind(this);
  }

  componentDidMount () {
    this.fetchCustomer();
  }

  componentWillUnmount () {
    if (this.state.pendingRequestGetById) {
      this.state.pendingRequestGetById.cancel();
    }
  }

  fetchCustomer () {
    this.setState({
      fetching: true
    });
    let pendingRequest = CustomerService.getById(this.props.params.id);
    pendingRequest.promise
      .then((response) => this.handleResponse(response))
      .catch(() => this.handleError());

    this.setState({
      pendingRequestGetById: pendingRequest
    });
  }

  handleError (error) {
    if (error.response !== undefined) {
      this.setState({
        fetchError: true
      });
    }
  }

  handleResponse (data) {
    this.setState({
      customer: Utils.getInputValueObjects(data),
      name: data.name,
      fetching: false
    });
  }

  setCountry (country) {
    this.newValueFromChild('country', {value: country, valid: true});
    this.validateCountryOrgnr();
  }

  setPayTerms (payTerms) {
    this.newValueFromChild('payTerms', {value: payTerms, valid: true});
  }

  newValueFromChild (name, values) {
    var tempFormValues = this.state.customer;

    Object.assign(tempFormValues[name], values);
    this.setState({customer: tempFormValues});
  }

  submitForm () {
    var params = Utils.getPostParams(this.state.customer);

    this.setState({
      posting: true,
      customerUpdated: false,
      postError: false
    });

    CustomerService.updateBillingEmails(params.id, params)
    .then(() => {
      CustomerService.update(params.id, params)
      .then(
        (customer) => {
          this.handleResponse(customer);

          this.setState({
            posting: false,
            name: customer.name,
            customerUpdated: true,
            postError: false
          });
        },
        () => {
          this.setState({
            posting: false,
            customerUpdated: false,
            postError: true
          });
        }
      );
    });
  }

  /**
   * If country isn't Sweden a Org number is required
   * @returns {boolean}
   */
  validateCountryOrgnr () {
    let countryOrgNumInvalid = this.state.customer.country.value !== 'SWEDEN' && this.state.customer.vatNr.value === '';

    this.setState({
      countryOrgNumError: countryOrgNumInvalid
    });

    return !countryOrgNumInvalid;
  }

  clickSubmit (e) {
    e.preventDefault();

    this.setState({showErrorWithoutBlur: true}, () => {
      if (Utils.validateInputValues(this.state.customer) && this.validateCountryOrgnr()) {
        this.submitForm();
      }
    });
  }

  getContent () {
    if (this.state.fetchError) {
      return (<GeneralError />);
    } else if (this.state.fetching) {
      return this.renderLoader();
    }

    return this.renderForm();
  }

  renderLoader () {
    return (
      <div className='loader-wrapper'>
        <Spinner />
      </div>
    );
  }

  renderPostSuccess () {
    return (
      <p className='info'><Translate content='CUSTOMER_UPDATED' name={this.state.name} /></p>
    );
  }

  renderCountryOrgNumberError () {
    if (this.state.countryOrgNumError) {
      return (
        <p className='error'><Translate content='ORG_NR_ERROR' /></p>
      );
    }
  }

  renderPayTermsMessage () {
    if (parseInt(this.state.customer.payTerms.value) < 30) {
      return (
        <p className='info'><Translate content='PAYTERMS_LOW_WARNING'/></p>
      );
    }
    if (parseInt(this.state.customer.payTerms.value) > 30) {
      return (
        <p className='info'><Translate content='PAYTERMS_HIGH_WARNING'/></p>
      );
    }
  }

  renderForm () {
    var postError, customerUpdated, disableVatInput;

    postError = this.state.postError ? (<GeneralError />) : false;
    customerUpdated = this.state.customerUpdated ? this.renderPostSuccess() : false;
    disableVatInput = (this.state.customer.vatNr.value.length > 0) ? 'true' : 'false';

    return (
      <form action=''>
        <div className='form-row'>
          <InputField type='text' name='name' value={this.state.customer.name.value}
            placeholder={proxyCounterpart('NAME')} callback={this.newValueFromChild}
            required='true' minLength='3' errorMessage={proxyCounterpart('NAME_ERROR')}
            showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
          <InputField type='text' name='contact' value={this.state.customer.contact.value}
            placeholder={proxyCounterpart('REF')} callback={this.newValueFromChild}
            required='true' minLength='0' maxLength='30' errorMessage={proxyCounterpart('REF_ERROR')}
            showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
        </div>
        <div className='form-row'>
          <InputField type='tel' name='vatNr' value={this.state.customer.vatNr.value}
            placeholder={proxyCounterpart('ORG_NR')} callback={this.newValueFromChild}
            required='true' minLength='0' errorMessage={proxyCounterpart('ORG_NR_ERROR')}
            showErrorWithoutBlur={this.state.showErrorWithoutBlur} disabled={disableVatInput} />
          <InputField type='text' name='co' value={this.state.customer.co.value}
            placeholder={proxyCounterpart('CO')} callback={this.newValueFromChild}
            required='true' minLength='0' errorMessage={proxyCounterpart('CO_ERROR')}
            showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
        </div>
        <div className='form-row'>
          <InputField type='text' name='street' value={this.state.customer.street.value}
            placeholder={proxyCounterpart('ADDRESS')} callback={this.newValueFromChild}
            required='true' minLength='3' errorMessage={proxyCounterpart('ADDRESS_ERROR')}
            showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
          <InputField type='text' name='zip' value={this.state.customer.zip.value}
            placeholder={proxyCounterpart('POSTAL_CODE')} callback={this.newValueFromChild}
            required='true' minLength='3' errorMessage={proxyCounterpart('POSTAL_CODE_ERROR')}
            showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
        </div>
        <div className='form-row'>
          <InputField type='text' name='city' value={this.state.customer.city.value}
            placeholder={proxyCounterpart('CITY')} callback={this.newValueFromChild}
            required='true' minLength='2' maxLength='40' errorMessage={proxyCounterpart('CITY_ERROR')}
            showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
          <CountryPicker
            setCountry={this.setCountry}
            countryName={this.state.customer.country.value}
            showErrorWithoutBlur={this.state.showErrorWithoutBlur}
          />
        </div>

        <div className='form-row'>
          <InputField type='email' name='sendToEmail' value={this.state.customer.sendToEmail.value}
            placeholder={proxyCounterpart('EMAIL_BILLING')} callback={this.newValueFromChild}
            required='true' minLength='0' errorMessage={proxyCounterpart('EMAIL_ERROR')}
            showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
          <InputField type='email' name='sendToEmailSecondary' value={this.state.customer.sendToEmailSecondary.value}
            placeholder={proxyCounterpart('EMAIL_BILLING_SECONDARY')} callback={this.newValueFromChild}
            required='true' minLength='0' errorMessage={proxyCounterpart('EMAIL_ERROR')}
            showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
        </div>

        <div className='form-row'>
          <InputField type='text' name='phone' value={this.state.customer.phone.value}
            placeholder={proxyCounterpart('TELEPHONE_NR')} callback={this.newValueFromChild}
            required='true' minLength='0' errorMessage={proxyCounterpart('TELEPHONE_ERROR')}
            showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
          <PayTermsPicker
            setPayTerms={this.setPayTerms}
            payTerms={this.state.customer.payTerms.value}
            renderErrorMessages={false}
          />
        </div>

        {this.renderPayTermsMessage()}

        {customerUpdated}
        {postError}
        {this.renderCountryOrgNumberError()}

        <div className='btn-wrapper'>
          <Link className='btn blue outlined' to='/customers'><Translate content='BACK'/></Link>
          <SpinnerButton text={proxyCounterpart('SAVE')}
            loading={this.state.posting} classes='btn' callback={this.clickSubmit}/>
        </div>
      </form>
    );
  }

  render () {
    var content = this.getContent();

    return (
      <div className='customer'>
        <h2><Translate content='EDIT_CUSTOMER'/></h2>
        {content}
      </div>
    );
  }
}

export default Customer;



/** WEBPACK FOOTER **
 ** ./src/views/customers/customer.js
 **/